module.exports = __webpack_public_path__ + "img/BETCITY.6a30908d.svg";